import Component from '@glimmer/component';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';
import { ConditionViewerBackgroundVariant } from 'cio/utils/condition-viewer';

export interface CioConditionViewerBaseArgs {
  condition: any;
  depth?: number;
  labelVariant?: DataSourceLabelVariant;
  backgroundVariant?: ConditionViewerBackgroundVariant;
}

export default class CioConditionViewerBase<
  T extends CioConditionViewerBaseArgs = CioConditionViewerBaseArgs,
> extends Component<T> {
  get isDepthEven() {
    return (this.args.depth ?? 0) % 2 === 0;
  }

  get backgroundVariant() {
    if (this.args.backgroundVariant != null) {
      return this.args.backgroundVariant;
    }

    if (this.args.depth == null) {
      return ConditionViewerBackgroundVariant.Dark;
    }

    return this.isDepthEven ? ConditionViewerBackgroundVariant.Light : ConditionViewerBackgroundVariant.Dark;
  }

  get labelVariant() {
    if (this.args.labelVariant != null) {
      return this.args.labelVariant;
    }

    return this.backgroundVariant === ConditionViewerBackgroundVariant.Dark
      ? DataSourceLabelVariant.Light
      : DataSourceLabelVariant.Dark;
  }

  get backgroundClass() {
    if (this.labelVariant === DataSourceLabelVariant.Unstyled) {
      return '';
    }

    return `cio-condition-viewer--bg-${this.backgroundVariant}`;
  }

  get oppositeBgClass() {
    let oppositeBg =
      this.backgroundVariant === ConditionViewerBackgroundVariant.Dark
        ? ConditionViewerBackgroundVariant.Light
        : ConditionViewerBackgroundVariant.Dark;
    return `cio-condition-viewer--bg-${oppositeBg}`;
  }
}
